"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollUtils = void 0;
var getScrollUtils = function () {
    var scrollTopElements = new Map();
    var getScrollTopInRange = function (el, range) {
        var _a;
        var currentScrollTop = el.scrollTop;
        var prevScrollTop = (_a = scrollTopElements.get(el)) !== null && _a !== void 0 ? _a : NaN;
        if (prevScrollTop - range <= currentScrollTop && prevScrollTop + range >= currentScrollTop) {
            return prevScrollTop;
        }
        scrollTopElements.set(el, currentScrollTop);
        return currentScrollTop;
    };
    return {
        getScrollTopInRange: getScrollTopInRange,
    };
};
exports.getScrollUtils = getScrollUtils;
//# sourceMappingURL=scroll.js.map